import __request__ from "routing/request";
export function recent(requestOptions) {
  return __request__("GET", "/collectors/activity/recent", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
